import { Profile } from "@zapier/copilot-ui";

/**
 * Helper function to create profile object from user data
 */
export const createUserProfile = (user: any) => {
  if (!user?.is_logged_in) {
    return { is_logged_in: false } as Profile;
  }

  return {
    is_logged_in: true,
    id: user.id || 0,
    current_account_id: user.current_account_id
      ? parseInt(user.current_account_id, 10)
      : 0,
    is_staff: user.is_staff || false,
    email: user.email,
    signup: user.signup,
    plan_type: null,
  } as Profile;
};
